angular.module('dentalLinks')
  .filter('destinationName', function () {
    function doctorName(provider) {
      var parts = [];
      if (provider.first_name) {
        parts.push(provider.first_name);
      }
      if (provider.last_name) {
        parts.push(provider.last_name);
      }
      return parts.length ? 'Dr. ' + parts.join(' ') : '';
    }

    // Builds a human-readable destination for a referral confirmation message:
    //   "Dr. Jane Smith at Bright Smiles Dental" — when a specific registered doctor is set
    //   "Bright Smiles Dental"                   — practice only (First Available / invited / unregistered)
    //   ""                                       — nothing to show; caller keeps the generic wording
    return function (referral) {
      if (!referral) {
        return '';
      }

      var practiceName = referral.dest_practice && referral.dest_practice.name;

      // Only name a specific doctor when a real, registered dest_provider exists.
      // dest_provider_id < 0 is the "First Available" placeholder, and invited /
      // not-yet-registered doctors have no positive dest_provider_id — both fall back
      // to the practice name.
      var doctor = '';
      if (referral.dest_provider_id > 0 && referral.dest_provider) {
        doctor = doctorName(referral.dest_provider);
      }

      if (doctor && practiceName) {
        return doctor + ' at ' + practiceName;
      }
      return doctor || practiceName || '';
    };
  });
